import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import ServicePaymentService from "@/core/services/ServicePaymentService";


@Module
export class ServicePaymentModule extends VuexModule {
  page: any = {
    loading: true,
    data: {
      total: 0,
      data: [],
      pages: 0,
    }
  }

  @Action
  [Actions.LOAD_PAYMENT_SERVICES](filter) {
    ServicePaymentService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_PAYMENT_SERVICES, {loading: false, data: res})
    })
  }

  @Mutation
  [Mutations.SET_PAYMENT_SERVICES](data) {
    this.page = data;
  }

}

